import React from "react";
import { IoClose } from "react-icons/io5";
import { IoDocumentOutline } from "react-icons/io5";
import { FaSave } from "react-icons/fa";
import { GiCrossMark } from "react-icons/gi";
import { IoPrintSharp } from "react-icons/io5";
import { useState, useEffect } from "react";
import axios from "axios";
import moment from "moment";
import Select from "react-select";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import vehicleMasterData from "../../../../store/VehicleMasterERP";

const Documentation = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sessiontoken = window.sessionStorage.getItem("session-token");
  const state = useSelector((state) => state.changeTheState);
  const user = state?.user?.emailId?.split("@")[0];
  const location = useLocation();
  const menu = location.state ? location.state.menu : null;
  const authToken = window.sessionStorage.getItem("auth-token");
 const BASEURL_GLOBAL =  process.env.REACT_APP_BASEURL_GLOBAL;
  const BASEURL = process.env.REACT_APP_BASEURL;
  const [isLoading, setIsLoading] = useState(true);
  const data = vehicleMasterData((state) => state.data);

  // VEHICLE RELATED
  const [make, setMake] = useState("");
  const [model, setModel] = useState("");
  const [trailerType, setTrailerType] = useState("");
  const [assetCategory, setAssetCategory] = useState("");

  const [formData, setFormData] = useState({
    document: "",
    startDate: new Date().toISOString(),
    expDate: new Date().toISOString(),
    path: "",
    note: "",
    refNo: "",
    data: [],
  });

  const handleChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  useEffect(() => {
    if (data?.OM_VEHICLE_REG_NO) {
      getData(data?.OM_VEHICLE_REG_NO);
    }
  }, [data]);

  const getData = (vehicle) => {
    axios
      .get(
        `${BASEURL_GLOBAL}/globalViewHandler?viewname=766&TRUCK=${encodeURIComponent(vehicle)}`,
        {
          headers: {
            "auth-token": authToken,
            "session-token": sessiontoken,
          },
        },
      )
      .then((res) => {
        handleChange("data", res?.data);
        // setIsLoading(false);
      })
      .catch((err) => {
        // setIsLoading(false);
        console.log("Error While fetching 766", err);
      });
  };
  return (
    <div className="text-xs">
      <div className=" mt-3 bg-gray-100 p-2 m-2 rounded-md">
       <aside className="visible lg:h-[300px] p-1 z-0 lg:overflow-auto mt-2">
            <table className="w-auto border border-gray-300 text-sm">
              <thead class="sticky top-0 w-44">
                <tr className="bg-[#2b3f5c] text-white text-[12px]">
                <td className="py-2 px-4  border border-gray-300 text-right">S NO</td>
                <td className="py-2 px-4  border border-gray-300 text-left">DOCUMENT</td>
                <td className="py-2 px-4  border border-gray-300 text-left">START DATE</td>
                <td className="py-2 px-4  border border-gray-300 text-left">EXP DATE</td>
                <td className="py-2 px-4  border border-gray-300 text-left">FILE PATH</td>
                <td className="py-2 px-4  border border-gray-300 text-left">REF NO</td>
                <td className="py-2 px-4  border border-gray-300 text-left">NOTE</td>
              </tr>
            </thead>
            <tbody>
              {formData?.data?.map((row, index) => (
                <tr
                                  className="hover:bg-gray-100 cursor-pointer text-[12px]"
                  key={index}
                  onClick={() => {
                    handleChange("document", row?.["DOCUMENT TYPE"]);
                    handleChange("startDate", row?.["DOC DATE"]);
                    handleChange("expDate", row?.["EXPIRY DATE"]);
                    handleChange("path", row?.["URLPATH"]);
                    handleChange("refNo", row?.["REFERENCE NO"]);
                    handleChange("note", row?.["NOTES"]);
                  }}
                >
                  <td className="py-2 px-4  border border-gray-300 text-right">{index + 1}</td>
                  <td className="py-2 px-4  border border-gray-300 text-left">
                    {row?.["DOCUMENT TYPE"] ? row?.["DOCUMENT TYPE"] : ""}
                  </td>
                  <td className="py-2 px-4  border border-gray-300 text-left">
                    {row?.["DOC DATE"]
                      ? moment(row?.["DOC DATE"]).format("DD/MM/YYYY")
                      : ""}
                  </td>
                  <td className="py-2 px-4  border border-gray-300 text-left">
                    {row?.["EXPIRY DATE"]
                      ? moment(row?.["EXPIRY DATE"]).format("DD/MM/YYYY")
                      : ""}
                  </td>
                  <td className="py-2 px-4  border border-gray-300 text-left">{row?.URLPATH ? row?.URLPATH : ""}</td>
                  <td className="py-2 px-4  border border-gray-300 text-left">{row?.["REFERENCE NO"] ? row?.["REFERENCE NO"] : ""}</td>
                  <td className="py-2 px-4  border border-gray-300 text-left">{row?.NOTES ? row?.NOTES : ""}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </aside>

        {/* 1st Row  */}
        <div className="flex">
          <span className="lg:ml-2">Document :</span>
          <Select
            className="w-40"
            value={
              formData?.document
                ? {
                    value: formData?.document,
                    label: formData?.document,
                  }
                : { value: "", label: "Select Document" }
            }
            onChange={(e) => handleChange("document", e.value)}
            // options={[
            //   { value: "", label: "Select Document" },
            //   ...formData?.data?.map((item) => ({
            //     value: item?.OM_VEHICLE_PROPELLER_1_SERIAL,
            //     label: item?.OM_VEHICLE_PROPELLER_1_SERIAL,
            //   })),
            // ]}
          ></Select>

          <span className="lg:ml-2  text-right">Date :</span>
          <input
            className="w-32 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="date"
            value={formData?.startDate?.split("T")[0]}
            onChange={(e) => handleChange("startDate", e.target.value)}
          ></input>
          <span className="lg:ml-2  text-right">Exp Date :</span>
          <input
            className="w-32 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="date"
            value={formData?.expDate?.split("T")[0]}
            onChange={(e) => handleChange("expDate", e.target.value)}
          ></input>
          <span className="lg:ml-2  text-right">Path :</span>
          <input
            className="w-64 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={formData?.path}
            onChange={(e) => handleChange("path", e.target.value)}
          ></input>
          <button className="flex h-7 items-center lg:ml-2 justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]">
            ...
          </button>
          <button className="flex h-7 items-center lg:ml-2 justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]">
            V
          </button>
        </div>

        {/* 2nd Row  */}
        <div className="flex lg:mt-2">
          <span className="lg:ml-2  text-right">Note :</span>
          <input
            className="w-96 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={formData?.note}
            onChange={(e) => handleChange("note", e.target.value)}
          ></input>
          <span className="lg:ml-2  text-right">Ref No :</span>
          <input
            className="w-64 h-7 border border-black rounded-md outline-none transition-colors duration-200 focus:border-blue-500 ml-2"
            type="text"
            value={formData?.refNo}
            onChange={(e) => handleChange("refNo", e.target.value)}
          ></input>
          <button className="flex h-7 items-center lg:ml-2 justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]">
            Add
          </button>
          <button className="flex h-7 items-center lg:ml-2 justify-center px-3 py-1 border border-black bg-[#002d62] text-white outline-none transition duration-200 ease-in-out hover:border-gray-700 focus:ring focus:border-blue-300 mb-[1px]">
            Remove
          </button>
        </div>
      </div>
    </div>
  );
};

export default Documentation;
